// copy page url to clipboard
function copyToClipboard(string) {
    // for reference: https://stackoverflow.com/questions/34045777/copy-to-clipboard-using-javascript-in-ios

    let dummyInput,
        result;

    try {
        dummyInput = document.createElement('input');
        dummyInput.setAttribute('readonly', true);
        dummyInput.setAttribute('contenteditable', true);
        dummyInput.style.position = 'fixed'; // prevent jumping to bottom (iOS)
        dummyInput.style.top = 50+'%'; // prevent jumping to bottom (iOS)
        dummyInput.value = string;

        document.body.appendChild(dummyInput);

        dummyInput.focus();
        dummyInput.select();

        const range = document.createRange();
        range.selectNodeContents(dummyInput);

        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);

        dummyInput.setSelectionRange(0, dummyInput.value.length);
        result = document.execCommand('copy');
    } catch (err) {
        console.error(err);
        result = null;
    } finally {
        document.body.removeChild(dummyInput);
    }
}

$('.social-share__link--url').on('click', function() {
    let $link = $(this),
        classShowTooltip = 'social-share__link--show-tooltip',
        currentUrl = window.location.href;

    copyToClipboard(currentUrl);

    if (!$link.hasClass(classShowTooltip)) {
        $link.addClass(classShowTooltip);

        setTimeout( function() {
            $link.removeClass(classShowTooltip);
        }, 1000);
    }
});
